<script setup>
import { ref, computed, getCurrentInstance, onMounted, onUnmounted } from 'vue'
import { $router } from '@/router'
import { $bus, mqtt } from '@/common/events'
import { nanoid } from '@/common/helper'
import { dialog } from '@/common/dialog'
import { hcu } from '@/common/hcu'
import { useTitle } from '@/composables/title'
import { useMenu, useSubmenu, useTopBar } from '@/composables/menu'
import { canInterrupt } from '@/composables/interrupt'
import { useSessionTimer } from '@/composables/session'

const instance = getCurrentInstance();

const message = ref(null);

onMounted(() => {
  useTitle("Napaka");
  useMenu(false);
  useSubmenu(false);
  useTopBar(false);

  //Do not allow any external event interruptions (such as id card scanning)
  canInterrupt(false);

  //Avoid session timeout while a tray is open
  useSessionTimer(false);
});

onUnmounted(() => {
  //Restore interruptions
  canInterrupt(true);
});

function home() {
  window.location = "/";
}
</script>

<template>

  <!-- Technical error message -->
  <div class="screen-container">
    <div class="text-center">
      <i class="fa fa-exclamation-triangle text-amber-400 huge-icon"></i>
      <div class="mt-5 text-lg font-bold">{{ $t('error.title') }}</div>
      <div class="mt-5">{{ $t('error.message') }}</div>
      <div class="mt-5">
        <Button type="primary" @click="home()">{{ $t('error.home') }}</Button>
      </div>
    </div>
  </div>

</template>

<style scoped>
.screen-container {
  @apply grid min-h-screen place-items-center dark:bg-gray-800 dark:text-white;
}

.huge-icon {
  font-size: 210px;
}
</style>
